import { render, staticRenderFns } from "./vote-component.vue?vue&type=template&id=305bc3c9&scoped=true"
import script from "./vote-component.ts?vue&type=script&lang=ts&external"
export * from "./vote-component.ts?vue&type=script&lang=ts&external"
import style0 from "./vote-component.scss?vue&type=style&index=0&id=305bc3c9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305bc3c9",
  null
  
)

export default component.exports